import { jsonLdScript } from "@/lib/jsonld";

// Hidden descriptive metadata helper to improve text-to-HTML ratio for
// crawler parsers (Semrush / Google). Emits a WebPage JSON-LD block with
// a clean description. Zero visual UI impact.

export type WebPageScriptInput = {
  path: string;
  name: string;
  description: string;
};

const BASE = "https://onlinetaxvat.com";

export function webPageScript(input: WebPageScriptInput) {
  const url = `${BASE}${input.path}`;
  const data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${url}#webpage`,
    url,
    name: input.name,
    description: input.description,
    inLanguage: ["en", "bn"],
    isPartOf: { "@type": "WebSite", "@id": `${BASE}#website`, url: BASE, name: "Online Tax VAT Bangladesh" },
    publisher: { "@type": "Organization", "@id": `${BASE}#organization`, name: "Online Tax VAT Bangladesh" },
    primaryImageOfPage: { "@type": "ImageObject", url: `${BASE}/og-cover.jpg` },
  };
  return jsonLdScript(data);
}
